import { computed, type Ref } from 'vue'
import { REFERENCES } from '@/lib/references'
import { useColorsStore } from '@/ContextTab/stores/colors'


export function useNewsPublishedEntry({
  item,
}: {
  item: Ref<any>
}) {
  const colorsStore = useColorsStore()

  const itemId = computed(() => item.value?.id)
  const version = computed(() => item.value.version)

  const highlightedCodes = computed(() => {
    return colorsStore.newsColoredCodes[itemId.value] || []
  })

  const isRevoked = computed(() => item.value.is_revoked)
  const isUrgent = computed(() => version.value?.type_id < 3)

  const isReleased = computed(() =>
    REFERENCES.News.Status[item.value.version.status_id]?.name === 'PUBLISHED',
  )

  return {
    highlightedCodes,
    isRevoked,
    isUrgent,
    isReleased,
  }
}
